import { strike as strikeFactory } from '../../next-schema/generated/markTypes';

/**
 * @name strike_mark
 */

export var strike = strikeFactory({
  parseDOM: [{
    tag: 'strike'
  }, {
    tag: 's'
  }, {
    tag: 'del'
  }, {
    style: 'text-decoration',
    getAttrs: function getAttrs(value) {
      return value === 'line-through' && null;
    }
  }],
  toDOM: function toDOM() {
    return ['s'];
  }
});